<template>
  <div>
    <TopBar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-3" style="padding:20px;">
          <MenuSetup />
        </div>
        <div class="col-sm-7">
          <div style="margin:40px;">
              <div v-if="!mac">
                <div style="line-height: 24px; font-size: 16px; font-weight: bold;">
                    {{ $t('updateProg') }}
                </div>
                <div style="margin: 5px auto; margin-top: 10px;">
                    <a class="linkDwn" href="/app/drivers/usbhf/maj/" target="_blank">
                        <img src="../assets/prog_usb2.png" style="height: 20px; margin-right: 10px;"> {{ $t('download') }}
                    </a>
                </div>
              </div>
              <div v-if="!mac && lShowKiBolt">
                <div style="line-height: 24px; font-size: 16px; font-weight: bold; margin-top: 30px;">
                  {{ $t('updateKiProg') }}
                </div>
                <div style="margin: 5px auto; margin-top: 10px;">
                    <a class="linkDwn" href="/app/update/kiprog/" target="_blank">
                      <img src="static/img/kiprog.png" style="height: 20px; margin-right: 10px;"> {{ $t('download') }}
                  </a>
              </div>
              </div>
              <div style="line-height: 24px; font-size: 16px; font-weight: bold; margin-top: 30px;">
                  {{ $t('dwnSetupFull') }}
              </div>
              <div v-if="!mac" style="margin: 5px auto; margin-top: 10px;">
                  <a class="linkDwn" href="/app/win/WSProgrammerFull235.exe" target="_blank">
                      {{ $t('dwnSetupFullProg') }}
                  </a>
              </div>
              <div v-if="mac" style="margin: 5px auto; margin-top: 10px;">
                  <a class="linkDwn" v-bind:href="linkMac" target="_blank">
                      {{ $t('dwnSetupFullProg') }}
                  </a>
              </div>
              <div v-if="!mac && lShowKiBolt" style="margin: 5px auto; margin-top: 10px;">
                  <a class="linkDwn" href="/app/win/WSProgrammerFull235.exe" target="_blank">
                      {{ $t('dwnSetupFullKiProg') }}
                  </a>
              </div>
              <div v-if="mac && lShowKiBolt" style="margin: 5px auto; margin-top: 10px;">
                  <a class="linkDwn" v-bind:href="linkMac" target="_blank">
                      {{ $t('dwnSetupFullKiProg') }}
                  </a>
              </div>
          </div>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'
import MenuSetup from './MenuSetup.vue'

export default {
  name: 'Tools',
  components: {
      TopBar,
      MenuSetup
  },
  data: function() {
    return {
      mac : false,
      linkMac : 'https://apps.apple.com/fr/app/programmateur/id1472162168?mt=12',
      linkWin : '',
    }
  },
  computed: {
      lShowKiBolt () {
        return this.$store.state.showKibolt;
      }
  },
  created(){
    /* /app/mac/programmateur107.pkg */
    document.title = this.$i18n.t(`titleProg`);
    this.mac = this.isMac();
  },
  methods: {
    isMac(){
      //alert('created config is '+JSON.stringify(this.config));
      let platform = window.navigator.platform
      let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
      if (macosPlatforms.indexOf(platform) !== -1) {
        return true;
      }else{
        return false;
      }
    },
    showKibolt(){
    }
  }
}
</script>
<style scoped>
  a.linkDwn {
      margin-left: 20px;
      width: auto;
      padding: 10px 20px;
      margin-bottom: 20px;
      display: block;
      background: #f2f2f2;
      border-radius: 10px;
      text-align: left;
      color:#222!important;
      text-decoration: none;
  }
  a.linkDwn:hover {
      /*background: #aaa;*/
      background: #0f66aa;
      color:#fff!important;
      text-decoration: none;
  }
  a.linkDwn span {
      display: block;
  }
  a.linkDwn img {
      height: 20px;
  }
</style>
